import { render, staticRenderFns } from "./BatchDownloads.vue?vue&type=template&id=4941d7be&"
import script from "./BatchDownloads.vue?vue&type=script&lang=js&"
export * from "./BatchDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports